document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
function MenuHeight (container) {
  var hdr = document.getElementById('header-toolbar');
  var stky = hdr.getAttribute('data-sticky');  
  if (stky == 'true') {
    document.selectors = {
      sht: hdr.offsetHeight
    };
  } else {
    document.selectors = {
      sht: 0
    };
  };
  const sN = container.querySelector('.sticky-navigation-container').offsetHeight;
  var iH = window.innerHeight;
  var cD = document.querySelector('#cart-dropdown span');
  var rM = container.querySelector('.responsiveMenu');
  if (cD) {
    var cDl = document.querySelector('#cart-dropdown .buttons').offsetHeight;
    if (theme.mobile == true) {
      cD.style.maxHeight = (iH - sN - cDl - 30) + 'px';
    } else {
      cD.style.maxHeight = (iH - sN - cDl) / 2 + 'px';
    }
  }
  rM.style.maxHeight = (iH - sN - 20) + 'px';
  if (rM.classList.contains('isDesktop')) {
    var pLu = rM.querySelectorAll('.parent-level-ul');
    pLu.forEach(function(p) {
      if (p) {
        p.style.maxHeight = iH - parseInt(document.selectors.sht) - 40 + 'px'; 
      }
    });
  }
};
theme.Header = (function() {
  function Header(container) {
    var sectionId = container.getAttribute('data-section-id');
    var dD = container.getAttribute('data-dropdown');
    var t = container.querySelector('.toggleMenu');
    var r = container.querySelector('.responsiveMenu');
    var hS = container.querySelector('#header-navigation .search details');
    var cCM = document.getElementById('cart-count-mobile');
    var cCMa = cCM.querySelector('.cart-count-mobile');
    var cCMb = container.querySelector('#cart-dropdown .modal-close');
    var m = container.getAttribute('data-multi');
    var pS = JSON.parse(document.getElementById('shopify-features').textContent);
    function menuWidth() {      
      const pL = document.querySelectorAll('.visually-hidden .visually-hidden-links');
      theme.nW = 0;
      pL.forEach(function(p) {
        theme.nW += p.offsetWidth + 5;
      });
    }
    if(dD == 'true'){
      theme.dropdown = true;
    } else {
      theme.dropdown = false;
    }
    theme.cart = false;
    if(('ontouchstart' in document.documentElement) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)){
      theme.detectmob = true;
    } else {
      theme.detectmob = false;
    }
    function menuAdjust() {
      var iW = document.body.scrollWidth;
      var nW = theme.nW;
      var mMW = parseInt(document.querySelector('.responsiveMenu').getAttribute('data-maxmobilewidth'));
      var tW = iW - 40 - parseInt(container.getAttribute('data-logo-width'));      
      if (nW > tW) {
        theme.updateNav = true;
      } else {
        theme.updateNav = false;
      }
      var tM = document.querySelector('.toggleMenu');
      var rM = document.querySelector('.responsiveMenu');
      var cD = document.getElementById('cart-dropdown');
      var cCM = document.getElementById('cart-count-mobile');
      var cCD = document.getElementById('cart-count-desktop');
      var rMl = rM.querySelectorAll('li');
      var dO = document.querySelectorAll('.open-container.desktop > details');
      if (theme.detectmob) { 
        document.body.classList.add('true-mobile');
      }      
      if (iW <= 583) {
        dO.forEach(function(d) {
          d.open = false;
        });
      } else {
        dO.forEach(function(d) {
          d.open = true;
        });
      }
      if (iW <= mMW || theme.updateNav || theme.detectmob) { 
        tM.classList.remove('isDesktop');
        tM.classList.add('isMobile');
        if (!tM.classList.contains('active')) {
          rM.style.display = 'none';
        } else {
          rM.style.display = 'block';
        }
        rM.classList.remove('isDesktop');
        rM.classList.add('isMobile');
        var pLu = rM.querySelectorAll('.parent-level-ul');
        pLu.forEach(function(p) {
          p.removeAttribute('style')
        });
        rMl.forEach(function(r) {
          r.onmouseenter = function(ev){
            return false;
          };      
          r.onmouseleave = function(ev){
            return false;
          };
          r.classList.remove('isDesktop');
          r.classList.add('isMobile');
        });
        var rMp = rM.querySelectorAll('li.has-dropdown a.parent');
        rMp.forEach(function(r) {
          r.onclick = function(ev){
            var pE = r.parentElement;
            if((r.getAttribute('href') != 'undefined') && r.getAttribute('href') != '#' && ev.target.matches('span')){          
            } else {
              ev.preventDefault();
              pE.classList.toggle('hover');
              pE.querySelector('a.parent').toggleAttribute('aria-expanded');
            }
          };
        });
        if (cD) {
          cCM.appendChild(cD);
        };
        theme.mobile = true;
        document.body.classList.remove('desktop-only');
        document.body.classList.add('mobile-only');        
      } else if (iW > mMW) {
        var hoverTimeout;    
        tM.classList.remove('isMobile');
        tM.classList.add('isDesktop');
        rM.style.display = 'block';
        rM.classList.remove('isMobile');
        rM.classList.add('isDesktop');
        rMl.forEach(function(r) {
          r.classList.remove('hover','isMobile');
          r.classList.add('isDesktop');
        });
        var rMp = rM.querySelectorAll('li.parent');
        rMp.forEach(function(r) {
          r.onmouseenter = function(ev){
            var rMh = rM.querySelectorAll('li.hover');
            rMh.forEach(function(r) {
              r.classList.remove('hover');
            });
            clearTimeout(hoverTimeout);
            r.classList.add('hover');
            r.querySelector('a.parent').setAttribute('aria-expanded','true');
          };      
          r.onmouseleave = function(ev){
            hoverTimeout = setTimeout(function() {
              r.classList.remove('hover');
              r.querySelector('a.parent').setAttribute('aria-expanded','false');
            },250);
          };
          r.addEventListener('keydown', e => {
            if (32 <= e.keyCode && e.keyCode <= 40) {
              e.preventDefault();
              e.stopPropagation();
              switch (e.keyCode) {
                case 32:
                  r.classList.toggle('key');
                  break;
                case 38:
                  r.classList.remove('key');
                  break;
                case 40:
                  r.classList.add('key');
                  break;
              }
            }
          });
        });
        if (cD) {
          cCD.appendChild(cD);
        };
        theme.mobile = false;
        document.body.classList.remove('mobile-only');
        document.body.classList.add('desktop-only');
      }
    }    
    if (location.pathname == '/challenge') {
      window.location.hash = '';
      window.scrollTo(0, 0);      
    } else if (window.location.hash) {
      setTimeout(function () {
        var hsh = location.hash;
        var hc = document.querySelector(hsh);
        if (!hc) {
          return;
        }
        var s = hc.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({top:s-document.selectors.sht, behavior: 'smooth'});
      }, 1);
    } else if (window.location.href.indexOf('customer_posted') > -1 || window.location.href.indexOf('contact?contact_posted') > -1) {
      if (document.cookie.split('AveForm=popUp').length == 1) {
        MenuHeight(container,theme.mobile);
        var fb = document.querySelector('.feedback'); 
        if (!fb) {
          return; 
        }
        var s = fb.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({top:s-document.selectors.sht, behavior: 'smooth'});
      }
    }    
    t.onclick = function(ev){
      ev.preventDefault();
      t.classList.toggle('active');
      if (r.style.display === 'none') {
        r.style.display = 'block';
        t.setAttribute('aria-expanded','true');
      } else {
        r.style.display = 'none';
        t.setAttribute('aria-expanded','false');
      }
      document.body.classList.toggle('modal-active');
      document.body.classList.toggle('no-scroll');
      if (hS) {
        hS.open = false;
      }
      cCM.classList.remove('hover');
      if (cCMb && document.getElementById('cart-dropdown')) {
        container.querySelector('#cart-dropdown .modal-close').classList.add('hidden');
      }
    }
    if(theme.dropdown == true){
      cCMa.onclick = function(ev){
        cCM.classList.toggle('hover');
        if (cCMb && document.getElementById('cart-dropdown')) {
          container.querySelector('#cart-dropdown .modal-close').classList.add('hidden');
        }
        if (cCMa.classList.contains('void')) {
          ev.preventDefault();
        }
      }
    };
    var sT = document.querySelector('.skip-to');
    function wS(){
      menuAdjust();
      if(document.body.classList.contains('desktop-only')){
        t.classList.remove('active');
        document.body.classList.remove('no-scroll');
        document.body.style.position = '';
        document.body.style.left = 'auto';
        document.body.style.right = 'auto';
        document.body.style.top = 'auto';
      };
    }
    var cW = window.innerWidth;
    window.addEventListener('resize', function() {
      MenuHeight(container,theme.mobile);      
      if (cW == window.innerWidth) {
        return;
      }
      cW = window.innerWidth;
      wS();
    });    
    document.addEventListener('shopify:section:load', function(event) {
      menuWidth();
      menuAdjust();
    });
    menuWidth();
    menuAdjust();
    MenuHeight(container,theme.mobile);    
    theme.multiHead = m;
    if (theme.multiHead == 'true') {
      Multi();
    }
    var el = document.querySelectorAll('.open-container.search details');
    el.forEach(function(e) {
      e.onclick = function(ev){
        var moR = container.querySelector('.mobile-only .responsiveMenu');
        if(theme.mobile == true){
          var dd = document.getElementById('cart-count-mobile');
        } else {
          var dd = document.getElementById('cart-count-desktop');
        }
        dd.classList.remove('hover');
        dd.classList.add('avoid');
        var ddC = dd.querySelector('.modal-close');
        if (ddC) {
          ddC.classList.add('hidden');
        }
        setTimeout(function() {
          dd.classList.remove('avoid');
        }, 1);
        if(t.classList.contains('active')) {
          t.classList.remove('active');
          moR.style.display = 'none';
          moR.classList.remove('active');
          document.body.classList.remove('no-scroll');
          document.body.classList.remove('modal-active');
          document.body.style.position = '';
          document.body.style.left = 'auto';
          document.body.style.right = 'auto';
          document.body.style.top = 'auto';
        }
        var sF = e.querySelector('.search-field');
        setTimeout(function () {
          if (e.hasAttribute('open')) {
            sF.focus();
          } else {
            sF.blur();
          }
        }, 0);
        if (e.hasAttribute('open')) {
          sF.blur();
        } else {
          sF.focus();
        }
      }
    });
    var cL = container.querySelectorAll('.customer-links ul li:not(.search)');
    cL.forEach(function(c) {
      c.addEventListener('keydown', e => {
        if (32 <= e.keyCode && e.keyCode <= 40) {
          e.preventDefault();
          e.stopPropagation();
          switch (e.keyCode) {
            case 32:
              c.classList.toggle('key');
              break;
            case 38:
              c.classList.remove('key');
              break;
            case 40:
              c.classList.add('key');
              break;
          }
        }
      });
    });
    if(container.getAttribute('data-search') == 'true'){
      function debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
      class PredictiveSearch extends HTMLElement {
        constructor() {
          super();
          this.cachedResults = {};
          this.input = this.querySelector('input[type="text"]');
          this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
          this.predictiveSearchResultsTop = this.getBoundingClientRect().top;
          this.isOpen = false;
          this.setupEventListeners();
        }
        setupEventListeners() {    
          const form = this.querySelector('form.search');
          const btn = this.querySelector('.modal-close');
          const ps = this;    
          form.addEventListener('submit', this.onFormSubmit.bind(this));
          this.input.addEventListener('input', debounce((event) => {
            this.onChange(event);
          }, 300).bind(this));
          this.input.addEventListener('focus', this.onFocus.bind(this));
          this.addEventListener('focusout', this.onFocusOut.bind(this));
          this.addEventListener('keyup', this.onKeyup.bind(this));
          this.addEventListener('keydown', this.onKeydown.bind(this));
          btn.addEventListener('click', function(ev) {
            ps.close();
            ev.preventDefault();
          }, false);
        }
        getQuery() {
          return this.input.value.trim();
        }
        onChange() {
          const searchTerm = this.getQuery();
          if (!searchTerm.length) {
            this.close(true);
            return;
          }
          this.getSearchResults(searchTerm);
        }
        onFormSubmit(event) {
          if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
        }
        onFocus() {
          const searchTerm = this.getQuery();
          if (!searchTerm.length) return;
          if (this.getAttribute('results') === 'true') {
            this.open();
          } else {
            this.getSearchResults(searchTerm);
          }
        }
        onFocusOut() {
          setTimeout(() => {if (!this.contains(document.activeElement)) this.close();})
        }
        onKeyup(event) {    
          if (!this.getQuery().length) this.close(true);    
          event.preventDefault();
          switch (event.code) {
            case 'ArrowUp':
              this.switchOption('up')
              break;
            case 'ArrowDown':
              this.switchOption('down');
              break;
            case 'Enter':
              this.selectOption();
              break;
          }
        }
        onKeydown(event) {
          if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {event.preventDefault();}
        }
        switchOption(direction) {
          if (!this.getAttribute('open')) return;
          const moveUp = direction === 'up';
          const selectedElement = this.querySelector('[aria-selected="true"]');
          const allElements = this.querySelectorAll('[role="option"]');
          let activeElement = this.querySelector('[role="option"]');
          if (moveUp && !selectedElement) return;
          if (!moveUp && selectedElement) {
            activeElement = selectedElement.nextElementSibling || allElements[0];
          } else if (moveUp) {
            activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
          }
          if (activeElement === selectedElement) return;
          activeElement.setAttribute('aria-selected', true);
          activeElement.setAttribute('tabindex', 0);
          activeElement.focus();
          if (selectedElement) {
            selectedElement.setAttribute('aria-selected', false);
            selectedElement.setAttribute('tabindex', -1);
          }
          this.input.setAttribute('aria-activedescendant', activeElement.id);
        }
        selectOption() {
          const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
          if (selectedProduct) selectedProduct.click();
        }
        getSearchResults(searchTerm) {
          const queryKey = searchTerm.replace(" ", "-").toLowerCase();
          if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
          }
          const search_limit = this.predictiveSearchResults.getAttribute('data-search-limit');
          const search_types = this.predictiveSearchResults.getAttribute('data-search-type');
          const search_fields = this.predictiveSearchResults.getAttribute('data-search-fields');
          if (pS.predictiveSearch == true) {
            var URL = theme.routes_predictive_search_url + '?section_id=predictive-search&q=' + encodeURIComponent(searchTerm) + '&' + encodeURIComponent('resources[type]') + '=' + search_types + '&' + encodeURIComponent('resources[fields]') + '=' + search_fields + '&' + encodeURIComponent('resources[limit]') + '=' + search_limit;
          } else {
            var URL = theme.routes_search_url + '?section_id=predictive-search&q=' + encodeURIComponent(searchTerm) + '&options[prefix]=last&' + encodeURIComponent('type') + '=' + search_types;
          }
          fetch(URL)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              this.close();
              throw error;
            }
            return response.text();
          })
          .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            this.cachedResults[queryKey] = resultsMarkup;
            this.renderSearchResults(resultsMarkup);
          })
          .catch((error) => {
            this.close();
            throw error;
          });
        }
        renderSearchResults(resultsMarkup) {
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.setAttribute('results', true);
          this.setLiveRegionResults();
          this.open();
        }
        setLiveRegionResults() {
          this.removeAttribute('loading');
        }
        getResultsMaxHeight() {
          this.resultsMaxHeight = window.innerHeight - this.getBoundingClientRect().top - 80;
          return this.resultsMaxHeight;
        }
        open() {
          if(theme.mobile == true){
            var dd = document.getElementById('cart-count-mobile');
          } else {
            var dd = document.getElementById('cart-count-desktop');
          }
          dd.classList.remove('hover');
          dd.classList.add('avoid');
          var ddC = dd.querySelector('.modal-close');
          if (ddC) {
            ddC.classList.add('hidden');
          };
          setTimeout(function() {
            dd.classList.remove('avoid');
          }, 1);
          this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
          this.setAttribute('open', true);
          this.input.setAttribute('aria-expanded', true);
          this.isOpen = true;
          this.querySelector('form.search').classList.add('active');
        }
        close(clearSearchTerm = false) {
          if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results');      
          }    
          this.querySelector('form.search').classList.remove('open');
          const selected = this.querySelector('[aria-selected="true"]');
          if (selected) selected.setAttribute('aria-selected', false);
          this.input.setAttribute('aria-activedescendant', '');
          this.removeAttribute('open');
          this.input.setAttribute('aria-expanded', false);
          this.resultsMaxHeight = false;
          this.querySelector('form.search').classList.remove('active');
          this.predictiveSearchResults.removeAttribute('style');
          this.isOpen = false;
        }
      }
      customElements.define('predictive-search', PredictiveSearch); 
	}
  }
  return Header;
})();